// extracted by mini-css-extract-plugin
export default {"container":"RH-z","innerContainer":"SH-z","multipleLines":"TH-z","heading":"UH-z","content":"VH-z","linkColor":"WH-z"};